import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export const Faq = () => {
  const [open, setOpen] = useState(-1);
  const toggle = (i) => setOpen((prev) => (prev === i ? -1 : i));

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-white px-6 py-28 md:px-12 md:py-40"
    >
      <div className="mx-auto grid max-w-[1200px] gap-12 md:grid-cols-[0.8fr_1.2fr] md:gap-20">
        <div className="md:sticky md:top-32 md:self-start">
          <Reveal>
            <p className="mb-6 text-[0.7rem] uppercase tracking-[0.3em] text-sage">
              Good to Know
            </p>
            <h2 className="font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl md:text-6xl">
              Frequently asked
              <br />
              <span className="italic text-forest">questions</span>
            </h2>
            <p className="mt-6 max-w-sm text-base font-light leading-relaxed text-stone">
              A few things worth knowing before your visit. If there's anything else on
              your mind, we're always happy to talk it through.
            </p>
          </Reveal>
        </div>

        <div className="border-t border-sage/40">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={i * 0.05}>
                <div className="border-b border-sage/40">
                  <button
                    type="button"
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => toggle(i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-6 py-6 text-left md:py-7"
                  >
                    <h3 className="font-serif text-xl tracking-tight text-ink md:text-2xl">
                      {f.q}
                    </h3>
                    <motion.span
                      animate={{ rotate: isOpen ? 135 : 0 }}
                      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      className="mt-1 shrink-0 text-sage"
                    >
                      <Plus size={24} strokeWidth={1.5} />
                    </motion.span>
                  </button>

                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        key="content"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p
                          data-testid={`faq-answer-${i}`}
                          className="max-w-xl pb-7 text-sm font-light leading-relaxed text-stone md:text-base"
                        >
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
